import React from 'react';
import { Box, StatusIndicator } from '@cloudscape-design/components';
import { CopilotMessage, useCopilot } from './CopilotContext';
import { CopilotMarkdown } from './CopilotMarkdown';
import { ASTRA_ICON_URL } from './brand';
import { formatMessageTime } from 'src/utils/dateUtils';

interface CopilotMessageBubbleProps {
  message: CopilotMessage;
}

function getUserInitials(userId: string): string {
  if (!userId) return '?';
  return userId.slice(0, 2).toUpperCase();
}

export function CopilotMessageBubble({ message }: CopilotMessageBubbleProps) {
  const { userId } = useCopilot();
  const isUser = message.role === 'user';

  return (
    <div
      className={`copilot-message-row ${isUser ? 'copilot-message-row--user' : 'copilot-message-row--agent'}`}
    >
      {!isUser && (
        <div
          className="copilot-message-avatar copilot-message-avatar--agent"
          role="img"
          aria-label="Astra"
        >
          <img className="copilot-message-avatar-img" src={ASTRA_ICON_URL} alt="" />
        </div>
      )}
      <div className="copilot-message-content">
        <div
          className={`copilot-message-bubble ${
            isUser
              ? 'copilot-message-bubble--user'
              : message.isError
                ? 'copilot-message-bubble--error'
                : 'copilot-message-bubble--agent'
          }`}
        >
          {isUser ? (
            <Box variant="p" color="inherit">
              {message.content}
            </Box>
          ) : message.isError ? (
            <StatusIndicator type="error">{message.content}</StatusIndicator>
          ) : (
            <CopilotMarkdown content={message.content} />
          )}
        </div>
        <span className="copilot-message-timestamp">
          {formatMessageTime(message.timestamp)}
        </span>
      </div>
      {isUser && (
        <div
          className="copilot-message-avatar copilot-message-avatar--user"
          role="img"
          aria-label="You"
        >
          {getUserInitials(userId)}
        </div>
      )}
    </div>
  );
}
